// ** React Imports
import { lazy } from 'react'

const PaymentFormRoutes = [
    {
        path: '/:id',
        exact: true,
        //strict: true,
        className: '',
        component: lazy(() => import('../../views/paymentForm'))
    },
    {
        path: '/check/:id/',
        //exact: true,
        //strict: true,
        className: '',
        component: lazy(() => import('../../views/paymentForm'))
    },
    {
        path: '/:id/check/',
        //exact: true,
        //strict: true,
        className: '',
        component: lazy(() => import('../../views/paymentForm'))
    },
    {
        path: '/:id/redirect/',
        //exact: true,
        //strict: true,
        className: '',
        component: lazy(() => import('../../views/paymentForm'))
    }
    ]

export default PaymentFormRoutes